import Button from 'components/shared/Button/Button';
import Typography from 'components/shared/Typography/Typography';

const Header = ({ goBack, step, isDisabled = false }) => {
  if (step === 'saved-cards')
    return (
      <div className="flex flex-wrap items-center gap-1">
        <Typography
          variant="label"
          color="neutral-800"
          weight="semibold"
          size="large"
          className="!text-xl capitalize">
          Pay estimate now
        </Typography>
      </div>
    );

  return (
    <div className="flex flex-wrap items-center gap-2">
      <Button
        icon="arrow-left-linear"
        variant="tertiary"
        color="neutral"
        size="large"
        isDisabled={isDisabled}
        onClick={goBack}
        aria-label="Go back"
      />
      <Typography
        variant="label"
        color="neutral-800"
        weight="semibold"
        size="medium"
        className="capitalize">
        Pay estimate now
      </Typography>
      <Typography
        variant="label"
        color="neutral-800"
        weight="semibold"
        size="medium"
        className="capitalize">
        / New card
      </Typography>
    </div>
  );
};

export default Header;
